import { useEffect } from 'react';

export const useLocalAutolinking = () => {
  // we add ids to headings in the page body
  // to allow content team to link to them
  // this is done after the first render, so that all headings are present in the DOM
  useEffect(() => {
    const updateHTags = () => {
      const h1s = document?.querySelectorAll('h1');
      const h2s = document?.querySelectorAll('h2');
      const h3s = document?.querySelectorAll('h3');
      const h4s = document?.querySelectorAll('h4');
      const h5s = document?.querySelectorAll('h5');

      const allHeadings = [
        ...Array.from(h1s),
        ...Array.from(h2s),
        ...Array.from(h3s),
        ...Array.from(h4s),
        ...Array.from(h5s),
      ];

      // we add ids to any headings that do not have it, to
      // allow content team to link to them
      for (const heading of allHeadings) {
        const id = heading.getAttribute('id');
        if (!id && heading?.textContent) {
          heading.setAttribute(
            'id',
            heading?.textContent
              ?.toLowerCase()
              ?.replace(/[^A-Za-z]/g, '')
              ?.toLowerCase()
          );
        }
      }
    };

    function isHeading(node: Node): node is HTMLElement {
      return (
        node.nodeType === Node.ELEMENT_NODE && // only elements
        /^H[1-6]$/.test((node as HTMLElement).tagName) // H1 … H6
      );
    }

    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        // Look at direct additions
        mutation.addedNodes.forEach((node) => {
          // The node itself might be a heading…
          if (isHeading(node)) {
            updateHTags();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    updateHTags();

    return () => {
      observer.disconnect();
    };
  }, []);
};
